// Entry for the 3D AI mascot. Everything that pulls in three.js loads lazily, in its own chunk.
import { lazy } from "react";

export const LazyAdyvanceMascot = lazy(() => import("./AdyvanceMascot"));
export const LazyAdyvanceMascotHead = lazy(() => import("./AdyvanceMascotHead"));
/** The log-in page's stage: root walks and pulls feature boards (D-063). */
export const LazyLoginStageScene = lazy(() => import("./LoginStageScene"));
export type { StageDrive } from "./LoginStageScene";
/** Light (no three.js until idle): the top-bar assistant button face. */
export { HeaderMascot } from "./HeaderMascot";
export { AssistantHello } from "./AssistantHello";
export { StrollingRoot } from "./StrollingRoot";
/** root head as a still picture: the small root icon (D-059). */
export { RootHead } from "./RootHead";
export type { AdyvanceMascotProps, MascotQuality, MascotState, MascotTuning } from "./mascot.types";
export {
  analyseSpeech,
  mascotStateFor,
  setAssistantSpeech,
  setAssistantStatus,
  useAssistantSession,
  type AssistantStatus,
} from "./assistantSession";
